"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = init;
exports.empty = empty;
const just_clone_1 = __importDefault(require("just-clone"));
function init(schema) {
    const def = schema._def;
    if (!("coerce" in def && def.coerce) &&
        schema.isNullable() &&
        def.typeName !== "ZodDefault") {
        return null;
    }
    switch (def.typeName) {
        case "ZodObject": {
            const outputObject = {};
            for (const [key, value] of Object.entries(def.shape())) {
                outputObject[key] = init(value);
            }
            return outputObject;
        }
        case "ZodRecord":
            return {};
        case "ZodString": {
            if (def.checks) {
                for (const check of def.checks) {
                    if (check.kind === "uuid") {
                        return crypto.randomUUID();
                    }
                }
            }
            return "";
        }
        case "ZodNumber":
            for (const check of def.checks || []) {
                if (check.kind === "max" || check.kind === "min") {
                    return check.value;
                }
            }
            return 0;
        case "ZodBigInt":
            return BigInt(0);
        case "ZodBoolean":
            return false;
        case "ZodDate":
            return new Date();
        case "ZodLiteral":
            return def.value;
        case "ZodEffects":
            return init(def.schema);
        case "ZodArray":
            return [];
        case "ZodTuple":
            return def.items.map((item) => init(item));
        case "ZodSet":
            return new Set();
        case "ZodMap":
            return new Map();
        case "ZodEnum":
            return def.values[0];
        case "ZodNativeEnum":
            // ref. https://github.com/colinhacks/zod/blob/6fe152f98a434a087c0f1ecbce5c52427bd816d3/src/helpers/util.ts#L28-L43
            return Object.values(def.values).filter((value) => typeof def.values[value] !== "number")[0];
        case "ZodUnion":
            return init(def.options[0]);
        case "ZodDiscriminatedUnion":
            return init(Array.from(def.options.values())[0]);
        case "ZodIntersection":
            return Object.assign(init(def.left), init(def.right));
        case "ZodFunction":
            return (..._) => init(def.returns);
        case "ZodLazy":
            return init(def.getter());
        case "ZodPipeline":
            return init(def.in);
        case "ZodDefault":
            return def.innerType._def.typeName === "ZodFunction"
                ? def.defaultValue()
                : (0, just_clone_1.default)(def.defaultValue());
        case "ZodNaN":
            return Number.NaN;
        case "ZodNull":
        case "ZodAny":
            return null;
        case "ZodOptional":
            return init(def.innerType);
        // case "ZodUndefined":
        // case "ZodVoid":
        // case "ZodUnknown":
        // case "ZodNever":
        default:
            return undefined;
    }
}
function empty(schema) {
    const def = schema._def;
    switch (def.typeName) {
        case "ZodObject": {
            const outputObject = {};
            for (const [key, value] of Object.entries(def.shape())) {
                outputObject[key] = empty(value);
            }
            return outputObject;
        }
        case "ZodRecord":
            return {};
        case "ZodArray":
            return [];
        case "ZodTuple":
            return def.items.map((item) => empty(item));
        case "ZodSet":
            return new Set();
        case "ZodMap":
            return new Map();
        case "ZodUnion":
            return empty(def.options[0]);
        case "ZodDiscriminatedUnion":
            return empty(Array.from(def.options.values())[0]);
        case "ZodIntersection":
            return Object.assign(empty(def.left), empty(def.right));
        case "ZodLazy":
            return empty(def.getter());
        case "ZodPipeline":
            return empty(def.in);
        case "ZodNullable":
        case "ZodOptional":
            return empty(def.innerType);
        case "ZodEffects":
            return empty(def.schema);
        case "ZodLiteral":
            return def.value;
        case "ZodNaN":
            return Number.NaN;
        case "ZodDefault":
            return def.innerType._def.typeName === "ZodFunction"
                ? def.defaultValue()
                : (0, just_clone_1.default)(def.defaultValue());
        default:
            return null;
    }
}
